import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProgramBlock from './ProgramBlock';
import HomepageIntro from '../Home/HomepageIntro';
import { emptyHomepageIntro, normalizeHomepageIntro } from '../../utils/homepageIntroUtils';

const ProgramsList = () => {
  const [programs, setPrograms] = useState([]);
  const [intro, setIntro] = useState(emptyHomepageIntro());
  const [isEnabled, setIsEnabled] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get('/api/programs'),
      axios.get('/api/homepage-intro')
    ])
      .then(([programsResponse, introResponse]) => {
        setPrograms(programsResponse.data?.sections || []);
        setIsEnabled(programsResponse.data?.isEnabled !== false);
        setIntro(normalizeHomepageIntro(introResponse.data));
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching homepage content:', error);
        setPrograms([]);
        setIsEnabled(true);
        setIntro(emptyHomepageIntro());
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <main className="main">
        <div className="container">
          <p>Загрузка...</p>
        </div>
      </main>
    );
  }

  return (
    <main className="main">
      <HomepageIntro intro={intro} />
      {isEnabled && programs.map((program) => (
        <div className="program-block" key={program.id}>
          <ProgramBlock program={program} />
        </div>
      ))}
    </main>
  );
};

export default ProgramsList;
